import React from 'react'
import AllQuotation from '../quotation/AllQuotation';
import { Route, Routes } from 'react-router-dom';
import Profile from '../profile/Profile';

const ProfileRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/view" element={<Profile />} />
            </Routes>
        </>
    )
}

export default ProfileRoutes;